import React from 'react'
import AboutUs from '../about-us'

const AboutUsEn = () => {
    return <AboutUs languageCode="en" />
}

export default AboutUsEn
